import {isListeningMode} from "./modesHelper";

export function isListeningPracticeMode(completedScenario) {
  return isListeningMode(completedScenario.mode) && completedScenario.submode === "practice";
}
